import React, { useState, useContext, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { lightTheme, darkTheme } from "../../assets/styles/Theme";
import { ThemeContext } from "../../utils/common/ThemeContext";
import Sidebar from "./Sidebar";
import Dashboard from "../../features/dashboard/Dashboard";
import Header from "./Header";
import { CssBaseline, Box, ThemeProvider, useMediaQuery } from "@mui/material";
import SampleAdd from "../../features/sample/SampleAdd";
import SampleView from "../../features/sample/SampleView";
import Login from "../../features/dashboard/Login";
import HideSidebar from "../../utils/common/HideSidebar";
import { PageDataProvider } from "../../utils/common/PageDataContext";
import ViewApproverGrn from "../../features/grn/ViewApproverGrn";
import ViewInitiatorGrn from "../../features/grn/ViewInitiatorGrn";
import CreateBrands from "../../features/settings/CreateBrands";
import CreateCategory from "../../features/settings/CreateCategory";
import CreateSubCategory from "../../features/settings/CreateSubCategory";
import CreateIndustry from "../../features/settings/CreateIndustry";
import CreateMeasuringUnits from "../../features/settings/CreateMeasuringUnits";
import CreatePackages from "../../features/settings/CreatePackages";
import CreateProducts from "../../features/settings/CreateProducts";

import CreateDocumentTypes from "../../features/settings/CreateDocumentTypes";
import ViewReturnGrn from "../../features/grn/ViewReturnGrn";
// @ts-ignore
import GrnPdf from "../../features/documents/GrnPdf";
import ViewDetailGrn from "../../features/grn/ViewDetailGrn";
// @ts-ignore
import DebitNotePdf from "../../features/documents/DebitNotePdf";
// @ts-ignore
import RejectionNotePdf from "../../features/documents/RejectionNotePdf";
// @ts-ignore
import ReturnNotePdf from "../../features/documents/ReturnNotePdf";
import CreateGrn from "../../features/grn/CreateGrn";
import EditGrn from "../../features/grn/EditGrn";
import ViewBrands from "../../features/settings/ViewBrands";
import ViewCategory from "../../features/settings/ViewCategory";
import ViewDocumentType from "../../features/settings/ViewDocumentType";
import ViewMeasuringunit from "../../features/settings/ViewMeasuringunit";
import ViewPackage from "../../features/settings/ViewPackage";
import ViewProduct from "../../features/settings/ViewProduct";
import ViewIndustry from "../../features/settings/ViewIndustry";
import ViewSubcatergory from "../../features/settings/ViewSubcatergory";
import ReturnGrn from "../../features/grn/ReturnGrn";
import Supplier from "../../features/supplier/Supplier";
import CreateSupplier from "../../features/supplier/CreateSupplier";
import ViewApproveSuppliers from "../../features/supplier/ViewApproveSuppliers";
import ApproveSupplier from "../../features/supplier/ApproveSupplier";
import ViewBank from "../../features/settings/ViewBank";
import CreateBank from "../../features/settings/CreateBank";
import ViewBranch from "../../features/settings/ViewBranch";
import CreateBranch from "../../features/settings/CreateBranch";
import SupplierProduct from "../../features/products/SupplierProduct";
import CreateSupplierProduct from "../../features/products/CreateSupplierProduct";
import ViewMappedProducts from "../products/ViewMappedProducts";
import ViewWarehouse from "../../features/settings/ViewWarehouse";
import CreateWarehouse from "../../features/settings/CreateWarehouse";
import ProductDoc from "../products/ProductDoc";
import ViewSupplierchargetype from "../../features/supplier/ViewSupplierchargetype";
import CreateSupchargetype from "../../features/supplier/CreateSupchargetype";
import Suppilersmapcharges from "../../features/supplier/Suppilersmapcharges";
import ViewMappedsupcharges from "../supplier/ViewMappedsupcharges";
import SetupSupCharges from "../../features/supplier/SetupSupCharges";
import ViewDetailsreturnGrn from "../../features/grn/ViewDetailsreturnGrn";
import CreateReason from "../../features/settings/CreateReason";
import ViewReason from "../../features/settings/ViewReason";
import ViewhoodReturnApproval from "../../features/grn/ViewhoodReturnApproval";
import ViewHistory from "../../features/grn/ViewHistory";
import GoodsReturnHistory from "../../features/grn/GoodsReturnHistory";
import ViewCharge from "../../features/settings/ViewCharge";
import CreateCharge from "../../features/settings/CreateCharge";
import EditReturnGrn from "../../features/grn/EditReturnGrn";
import ViewReturnDetails from "../../features/grn/ViewReturnDetails";
import ProtectedRoute from "../auth/ProtectedRoute";
import ViewReturnList from "../../features/grn/ViewReturnList";
import ViewDetailRtnGrn from "../../features/grn/ViewDetailRtnGrn";
import ViewPrintGrn from "../../features/grn/ViewPrintGrn";
import ViewGrnHistory from "../../features/grn/ViewGrnHistory";
import GrnViewPage from "../grid/GrnViewPage";
import GrnViewReturnPage from "../grid/GrnViewReturnPage";
import MyActionInitiator from "../../features/grn/MyActionInitiator";
import GoodsReturnHistoryByGrnID from "../../features/grn/GoodsReturnHistoryByGrnID";
import MyActionApprover from "../../features/grn/MyActionApprover";
import ViewDetailsreturnEditGrn from "../../features/grn/ViewDetailsreturnEditGrn";

const drawerWidth = 240;

const PageRouting: React.FC = () => {
  const themeContext = useContext(ThemeContext);
  if (!themeContext) {
    throw new Error("PageRouting must be used within a ThemeProviderComponent");
  }
  const { mode, toggleTheme } = themeContext;
  const theme = mode === "light" ? lightTheme : darkTheme;

  const [mobileOpen, setMobileOpen] = useState<boolean>(false);
  const [desktopOpen, setDesktopOpen] = useState<boolean>(true);
  const hideSidebar = HideSidebar();
  const location = useLocation();
  const isLoginPage = location.pathname === "/";

  // Detect if screen is tab size (between sm and md)
  const isTabView = useMediaQuery(theme.breakpoints.between("sm", "md"));

  // Auto collapse sidebar on tab view
  useEffect(() => {
    if (isTabView) {
      setDesktopOpen(false);
    } else {
      setDesktopOpen(true);
    }
  }, [isTabView]);

  const handleDrawerToggle = (): void => {
    setMobileOpen(!mobileOpen);
  };

  const handleDesktopToggle = (): void => {
    setDesktopOpen(!desktopOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <PageDataProvider>
        <>
          <CssBaseline />

          {isLoginPage ? (
            // === LOGIN PAGE LAYOUT ===
            <Box
              sx={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#fff",
              }}
            >
              <Routes>
                <Route path="/" element={<Login />} />{" "}
              </Routes>
            </Box>
          ) : (
            <Box
              sx={{
                display: { xs: 0, sm: "flex", md: "flex" },
                height: "100vh",
              }}
            >
              {!hideSidebar && (
                <Header
                  handleDrawerToggle={handleDrawerToggle}
                  handleDesktopToggle={handleDesktopToggle}
                  desktopOpen={desktopOpen}
                />
              )}
              {!hideSidebar && (
                <Box
                  component="nav"
                  sx={{
                    width: { sm: desktopOpen ? drawerWidth : 0 },
                    backgroundColor: theme.palette.background.paper,
                    flexShrink: { sm: 0 },
                    borderRight: "none",
                  }}
                  aria-label="mailbox folders"
                >
                  <Sidebar
                    handleDrawerToggle={handleDrawerToggle}
                    desktopOpen={desktopOpen}
                    toggleTheme={toggleTheme}
                  />
                </Box>
              )}
              <Box
                component="main"
                sx={{
                  p: { xs: 0, sm: 0, md: 2 },
                  px: { xs: 2, sm: 2, md: 2 },
                  width: {
                    sm: `calc(100% - ${desktopOpen ? drawerWidth : 0}px)`,
                  },
                  transition: "width 0.3s",
                  mt: { xs: 8, sm: 10, md: 8, lg: 8, xl: 8 },
                  pb: { xs: 2, sm: 16, md: 0 },
                }}
              >
                <Routes>
                  <Route path="/Login" element={<Login />} />
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard"
                    element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateGrn"
                    element={
                      <ProtectedRoute>
                        <CreateGrn />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/EditGrn"
                    element={
                      <ProtectedRoute>
                        <EditGrn />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/SampleView"
                    element={
                      <ProtectedRoute>
                        <SampleView />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/SampleAdd"
                    element={
                      <ProtectedRoute>
                        <SampleAdd />
                      </ProtectedRoute>
                    }
                  />
                  {/* <Route
                    path="/vreturngrn"
                    element={
                      <ProtectedRoute>
                        <ViewReturnGrn />
                      </ProtectedRoute>
                    }
                  /> */}

                    <Route
                    path="/vreturngrn"
                    element={
                      <ProtectedRoute>
                        <ViewReturnList />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vgrnhistory"
                    element={
                      <ProtectedRoute>
                        <ViewHistory />
                      </ProtectedRoute>
                    }
                  />
                    <Route
                    path="/vgrnpage"
                    element={
                      <ProtectedRoute>
                        <GrnViewPage />
                      </ProtectedRoute>
                    }
                  />
                      <Route
                    path="/vgrnrtnpage"
                    element={
                      <ProtectedRoute>
                        <GrnViewReturnPage />
                      </ProtectedRoute>
                    }
                  />
                   <Route
                    path="/vgrnnotes"
                    element={
                      <ProtectedRoute>
                        <ViewPrintGrn />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/GrnPdf"
                    element={
                      <ProtectedRoute>
                        <GrnPdf />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/DebitNotePdf"
                    element={
                      <ProtectedRoute>
                        <DebitNotePdf />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/RejectionNotePdf"
                    element={
                      <ProtectedRoute>
                        <RejectionNotePdf />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vgoodsrtnhistory"
                    element={
                      <ProtectedRoute>
                        <GoodsReturnHistory />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vgoodsrtnhistorybyid"
                    element={
                      <ProtectedRoute>
                        <GoodsReturnHistoryByGrnID />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ReturnNotePdf"
                    element={
                      <ProtectedRoute>
                        <ReturnNotePdf />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ViewDetailsreturnGrn"
                    element={
                      <ProtectedRoute>
                        <ViewDetailsreturnGrn />
                      </ProtectedRoute>
                    }
                  /> 
                     <Route
                    path="/ViewDetailsreturneditGrn"
                    element={
                      <ProtectedRoute>
                        < ViewDetailsreturnEditGrn/>
                      </ProtectedRoute>
                    }
                  />
                  
                  
                  ViewDetailsreturnEditGrn
                  <Route
                    path="/ViewReturnHistoryDetails"
                    element={
                      <ProtectedRoute>
                        <ViewReturnDetails />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ViewDetailGrn"
                    element={
                      <ProtectedRoute>
                        <ViewDetailGrn />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ViewGrnHistory"
                    element={
                      <ProtectedRoute>
                        <ViewGrnHistory />
                      </ProtectedRoute>
                    }
                  />
                   <Route
                    path="/ViewReturnsGrnDetails"
                    element={
                      <ProtectedRoute>
                        <ViewDetailGrn />
                      </ProtectedRoute>
                    }
                  />
                    <Route
                    path="/ViewReturnGrnDetails"
                    element={
                      <ProtectedRoute>
                        <ViewDetailRtnGrn />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vgrnapprovals"
                    element={
                      <ProtectedRoute>
                        <ViewApproverGrn />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vaddgrn"
                    element={
                      <ProtectedRoute>
                        <ViewInitiatorGrn />
                      </ProtectedRoute>
                    }
                  />
                    <Route
                    path="/vmyactionsinitiator"
                    element={
                      <ProtectedRoute>
                        <MyActionInitiator />
                      </ProtectedRoute>
                    }
                  />
                    <Route
                    path="/vmyactionsapprover"
                    element={
                      <ProtectedRoute>
                        <MyActionApprover />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vCreateCategory"
                    element={
                      <ProtectedRoute>
                        <ViewCategory />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateSubCategory"
                    element={
                      <ProtectedRoute>
                        <CreateSubCategory />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vsubcategory"
                    element={
                      <ProtectedRoute>
                        <ViewSubcatergory />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateIndustry"
                    element={
                      <ProtectedRoute>
                        <CreateIndustry />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vCreateIndustry"
                    element={
                      <ProtectedRoute>
                        <ViewIndustry />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vCreateMeasuringUnits"
                    element={
                      <ProtectedRoute>
                        <ViewMeasuringunit />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateMeasuringUnits"
                    element={
                      <ProtectedRoute>
                        <CreateMeasuringUnits />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateCategory"
                    element={
                      <ProtectedRoute>
                        <CreateCategory />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vCreatePackages"
                    element={
                      <ProtectedRoute>
                        <ViewPackage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreatePackages"
                    element={
                      <ProtectedRoute>
                        <CreatePackages />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vCreateProducts"
                    element={
                      <ProtectedRoute>
                        <ViewProduct />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateProducts"
                    element={
                      <ProtectedRoute>
                        <CreateProducts />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vCreateBrands"
                    element={
                      <ProtectedRoute>
                        <ViewBrands />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateBrands"
                    element={
                      <ProtectedRoute>
                        <CreateBrands />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vCreateDocumentTypes"
                    element={
                      <ProtectedRoute>
                        <ViewDocumentType />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateDocumentTypes"
                    element={
                      <ProtectedRoute>
                        <CreateDocumentTypes />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/Productdoc"
                    element={
                      <ProtectedRoute>
                        <ProductDoc />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ReturnGrn"
                    element={
                      <ProtectedRoute>
                        <ReturnGrn />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/Editreturngrn"
                    element={
                      <ProtectedRoute>
                        <EditReturnGrn />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vaddsupplier"
                    element={
                      <ProtectedRoute>
                        <Supplier />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateSupplier"
                    element={
                      <ProtectedRoute>
                        <CreateSupplier />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ViewApproveSuppliers"
                    element={
                      <ProtectedRoute>
                        <ViewApproveSuppliers />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ApproveSupplier"
                    element={
                      <ProtectedRoute>
                        <ApproveSupplier />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vCreateBanks"
                    element={
                      <ProtectedRoute>
                        <ViewBank />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateBank"
                    element={
                      <ProtectedRoute>
                        <CreateBank />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/VcreateBranch"
                    element={
                      <ProtectedRoute>
                        <ViewBranch />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/createBranch"
                    element={
                      <ProtectedRoute>
                        <CreateBranch />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vcharges"
                    element={
                      <ProtectedRoute>
                        <ViewCharge />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/Createcharges"
                    element={
                      <ProtectedRoute>
                        <CreateCharge />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vsupplierproducts"
                    element={
                      <ProtectedRoute>
                        <SupplierProduct />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/supplierproducts"
                    element={
                      <ProtectedRoute>
                        <CreateSupplierProduct />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vmappedproducts"
                    element={
                      <ProtectedRoute>
                        <ViewMappedProducts />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vwarehouseparameters"
                    element={
                      <ProtectedRoute>
                        <ViewWarehouse />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/warehouseparameters"
                    element={
                      <ProtectedRoute>
                        <CreateWarehouse />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vsuppliercharges"
                    element={
                      <ProtectedRoute>
                        <ViewSupplierchargetype />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/suppliercharges"
                    element={
                      <ProtectedRoute>
                        <CreateSupchargetype />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/mapsuppliercharges"
                    element={
                      <ProtectedRoute>
                        <Suppilersmapcharges />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vmapsuppliercharges"
                    element={
                      <ProtectedRoute>
                        <ViewMappedsupcharges />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/setupsupcharges"
                    element={
                      <ProtectedRoute>
                        <SetupSupCharges />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreatreReason"
                    element={
                      <ProtectedRoute>
                        <CreateReason />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vreasontypes"
                    element={
                      <ProtectedRoute>
                        <ViewReason />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vreturnapprovals"
                    element={
                      <ProtectedRoute>
                        <ViewhoodReturnApproval />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Box>
            </Box>
          )}
        </>
      </PageDataProvider>
    </ThemeProvider>
  );
};

export default PageRouting;
